
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import ColorScaleCompService from '@/services/ColorScaleComp.service';
import * as Tone from "tone";

const namespace = "CircularPianoModule";

@Component
export default class CircularPiano extends Vue {
  @Action('regenerateRelationArray', {namespace}) private regenerateRelationArray!: () => any;
  @Mutation('setSelectedNote', {namespace}) private setSelectedNote!: (value:number) => any;
  @Mutation('setPreviousNote', {namespace}) private setPreviousNote!: (value:number) => any;
  @Mutation('setColors', {namespace}) private setColors!: (value: string[]) => any;
  @Mutation('setDesc', {namespace}) private setDesc!: (value: boolean) => any;
  @Mutation('setStarted', {namespace}) private setStarted!: (value: boolean) => any;
  @Mutation('setShowChromatics', {namespace}) private setShowChromatics!: (value: boolean) => any;
  @State('selectedNote', { namespace }) private selectedNote!: number;
  @State('previousNote', { namespace }) private previousNote!: number;
  @State('colors', { namespace }) private colors!: string[];
  @State('showChromatics', { namespace }) private showChromatics!: boolean;
  @State('relationArray', { namespace }) private relationArray!: number[];
  @State('started', { namespace }) private started!: boolean;
  @State('synth', { namespace }) private synth!: any;
  @State('notes', { namespace }) private notes!: string[];
  @Mutation('setHueSlider', {namespace}) private setHueSlider!: (value:number) => any;
  @State('hueSlider', { namespace }) private hueSlider!: number;

  private mounted(){
    this.HLtoHEXs();
  }

  private HLtoHEXs(){
    const nNotes = 96;
    const baseHue = this.hueSlider;
    const colors = [];
    for(let i=0; i<nNotes; i++){
      colors[i] = ColorScaleCompService.HLtoHEX((baseHue+210*i)%360, 100*i/nNotes);
    }
    this.setColors(colors);
  }

  private async handleClick(value: number){
    if(this.started){
      this.synth.triggerAttackRelease(this.notes[this.relationArray[value]], "8n");
    }else{
      Tone.context.resume();
      this.setStarted(true);
    }
    
    this.setPreviousNote(this.selectedNote);
    this.setSelectedNote(value);
    if(this.previousNote>this.selectedNote){
      this.setDesc(true);
    }else if(this.previousNote<this.selectedNote){
      this.setDesc(false);
    }
    this.regenerateRelationArray();
  }

  private getColor(n: number) : string{
    return this.colors[this.relationArray[n]];
  }

  private handleChromaticButtonClick(){
    this.setShowChromatics(!this.showChromatics);
  }

  private centreColor() : string{
    return this.colors[this.relationArray[this.selectedNote]];
  }

  private handleHueSlider(event:any){
    this.setHueSlider(event.target.value);
    this.HLtoHEXs();
  }
}

